module.exports = "<button id=\"start-context\">Start AudioContext</button>\n"